/**************************************************************************************************
//
//  Description: Display list of ASD items
//
//  Copyright:    © 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   19.10.20 Peter Bryden               Initial Revision.
//    002   15.01.21 Sean Flook         WI39041 Added an Add button and associated events.
//    003   15.01.21 Sean Flook         WI39041 Correctly define the Spatial Designation Add onClick event.
//    004   26.01.21 Sean Flook         WI38232 Only display the add button if the user is allowed to create new records on this street.
//    005   29.01.21 Peter Bryden       WI38232 cleaned up code and handled save back to forms
//    006   02.02.21 Sean Flook         WI38232 Only allow editing of geometry if part of road selected.
//    007   03.03.21 Sean Flook         WI39198 Use Typography component to display the text.
//    008   09.03.21 Sean Flook         WI39166 Added tooltip to icons.
//    009   10.03.21 Sean Flook         WI39238 Added missing classNames to Special Designation list item.
//    009   11.03.21 Sean Flook         WI39198 Changed the special designation icon.
//    010   23.03.21 Peter Bryden       WI39243 Added in AAAssociatedStreetDataTieredListItem to show special designations
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion */

/* #region imports */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';

import Typography from '@material-ui/core/Typography';

import AAAssociatedStreetDataListItem from './AAAssociatedStreetDataListItem'
import AAAssociatedStreetDataTieredListItem from './AAAssociatedStreetDataTieredListItem';

import { brown, yellow, pink } from "@material-ui/core/colors";
/* #endregion imports */

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 450,
        backgroundColor: theme.palette.background.paper,
    },
    small: {
        width: theme.spacing(2),
        height: theme.spacing(2),
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    nested_1: {
        paddingLeft: theme.spacing(10),
    },
    pink: {
        color: theme.palette.getContrastText(pink[500]),
        backgroundColor: pink[500],
    },
    brown: {
        color: theme.palette.getContrastText(brown[500]),
        backgroundColor: brown[500],
    },
    yellow: {
        color: theme.palette.getContrastText(yellow[500]),
        backgroundColor: yellow[500],
    }

}));

const AAAssociatedStreetDataList = (props) => {
  const classes = useStyles();

  const asdData = props.asdData;
  const isEditable = props.editable;
  const onItemSelect = props.handleDetailsClick;

  const handleMaintenanceResponsibilitySelection = (pkId, dataIdx, dataLength, wholeRoad) => {  onItemSelect("MaintenanceResponsibility", pkId, dataIdx, dataLength, wholeRoad); }

  const handleReinstatementCategorySelection = (pkId, dataIdx, dataLength, wholeRoad) => { onItemSelect("ReinstatementCategory", pkId, dataIdx, dataLength, wholeRoad); }

  const handleSpecialDesignationSelection = (pkId, dataIdx, dataLength, wholeRoad) => { onItemSelect("SpecialDesignation", pkId, dataIdx, dataLength, wholeRoad); }

  const handleMaintenanceResponsibilityAdd = (dataLength) => {
    const newDataLength = dataLength + 1;
    onItemSelect("MaintenanceResponsibility", -1, dataLength, newDataLength, true);
  }

  const handleReinstatementCategoryAdd = (dataLength) => {
    const newDataLength = dataLength + 1;
    onItemSelect("ReinstatementCategory", -1, dataLength, newDataLength, true);
  }

  const handleSpecialDesignationAdd = (dataLength) => {
    const newDataLength = dataLength + 1;
    onItemSelect("SpecialDesignation", -1, dataLength, newDataLength, true);
  }

  const [Lookup_OSGRoadStatusCodes_data, setLookup_OSGRoadStatusCodes_data] = useState(props.Lookup_OSGRoadStatusCodes);
  const [Lookup_OSGReinstatementTypeCodes_data, setLookup_OSGReinstatementTypeCodes_data] = useState(props.Lookup_OSGReinstatementTypeCodes);
  const [Lookup_OSGSpecialDesignationCodes_data, setLookup_OSGSpecialDesignationCodes_data] = useState(props.Lookup_OSGSpecialDesignationCodes);
  const [Lookup_OSGSwaOrgRefs_data, setLookup_OSGSwaOrgRefs_data] = useState(props.Lookup_OSGSwaOrgRefs);

  const maintenanceResponsibilities = asdData.maintenanceResponsibilities;
  const reinstatementCatergories = asdData.reinstatementCatergories;
  const specialDesignations = asdData.specialDesignations;
  let specialDesignationTypes = specialDesignations && [...new Set(specialDesignations.map(sd => sd.specialDesignationCode))];

  //Find unique special designation types
  if (specialDesignationTypes) {
    var unique_specialDesignationTypes = [];
    specialDesignationTypes.map(d => unique_specialDesignationTypes.push({ "id": d, "name": Lookup_OSGSpecialDesignationCodes_data.find(x => x.streetSpecialDesigCode == d).streetSpecialDesigText }));
    specialDesignationTypes = unique_specialDesignationTypes;
    specialDesignationTypes.sort((a, b) => a.id - b.id);
  }

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          <Typography variant="body1">Associated Street Data</Typography>
        </ListSubheader>
      }
      className={classes.root}
    >
          <AAAssociatedStreetDataListItem title="Maintenance Responsibility" type="Type 51" itemIcon="PeopleRoundedIcon" colour="brown"
        itemSelect={(pkId, dataIdx, dataLength, wholeRoad) => handleMaintenanceResponsibilitySelection(pkId, dataIdx, dataLength, wholeRoad)}
              itemAdd={(dataLength) => handleMaintenanceResponsibilityAdd(dataLength)}
              data={maintenanceResponsibilities && maintenanceResponsibilities.map((mr) => {
                return { "id": mr.streetStatus, "displayText": `${Lookup_OSGRoadStatusCodes_data.find(g => g.roadStatusCode === mr.streetStatus).roadStatusText} - ${Lookup_OSGSwaOrgRefs_data.find(o => o.swaOrgRef === mr.maintainingAuthorityCode).swaOrgNameText}`, "pkId": mr.pkId, "wholeRoad": mr.wholeRoad };
              })}
        editable={isEditable} />

      <AAAssociatedStreetDataListItem title="Reinstatement Category" type="Type 52" itemIcon="BlurOnIcon" colour="pink"
        itemSelect={(pkId, dataIdx, dataLength, wholeRoad) => handleReinstatementCategorySelection(pkId, dataIdx, dataLength, wholeRoad)}
        itemAdd={(dataLength) => handleReinstatementCategoryAdd(dataLength)}
        data={reinstatementCatergories && reinstatementCatergories.map((rc) => (
          { "id": rc.streetReinstatementCategory, "displayText": `${Lookup_OSGReinstatementTypeCodes_data.find(g => g.streetReinstatementTypeCode === rc.streetReinstatementCategory).reinstatementTypeText} - ${Lookup_OSGSwaOrgRefs_data.find(o => o.swaOrgRef === rc.reinstatementAuthorityCode).swaOrgNameText}`, "pkId": rc.pkId, "wholeRoad": rc.wholeRoad }
        ))}
        editable={isEditable} />


      <AAAssociatedStreetDataTieredListItem title="Special Designations" type="Type 53" colour="yellow" 
        itemSelect={(pkId, dataIdx, dataLength, wholeRoad) => handleSpecialDesignationSelection(pkId, dataIdx, dataLength, wholeRoad)} 
        itemAdd={() => handleSpecialDesignationAdd(specialDesignations ? specialDesignations.length : 0) }
        tiers={specialDesignationTypes}  
        data={specialDesignations && specialDesignations.map((sd) => (
                { "tier_id" : sd.specialDesignationCode, "id": sd.specialDesignationCode, "displayText": `${sd.specificLocation ?? ''} ${sd.description}`, "pkId": sd.pkId, "wholeRoad": sd.wholeRoad }
        ))}
        editable={isEditable}
        />


    </List>
  );
};



export default AAAssociatedStreetDataList;
